import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { antiPatternValidator, passwordMatchValidator, patternValidator } from '../../../app-auth/login/login-internal/patient.account/password.validators';
var SetPasswordComponent = /** @class */ (function () {
    function SetPasswordComponent(changeDetector, sysConfigPreLogin, sysConfig, tokenProvider) {
        this.changeDetector = changeDetector;
        this.sysConfigPreLogin = sysConfigPreLogin;
        this.sysConfig = sysConfig;
        this.tokenProvider = tokenProvider;
        this.changePassword = false;
        this.passwordVisible = false;
        this.validateNumber = false;
        this.validateUpperChar = false;
        this.validateLowerChar = false;
        this.validateSpecialChar = false;
        this.validateLength = false;
        this.validateConsecutiveChars = false;
        this.passwordRecentlyUsed = false;
        this.invalidCharacters = false;
    }
    SetPasswordComponent.prototype.ngOnInit = function () {
        this.createGroup();
    };
    SetPasswordComponent.prototype.isValid = function () {
        if (this.formControls.controls.password.invalid) {
            return false;
        }
        this.invalidCharacters = false;
        try {
            var passwordEnc = btoa(this.formControls.controls['password'].value);
        }
        catch (e) {
            this.invalidCharacters = true;
            return false;
        }
        if (this.formControls.controls.confirmPassword.invalid) {
            return false;
        }
        return true;
    };
    SetPasswordComponent.prototype.togglePasswordVisibility = function () {
        this.passwordVisible = !this.passwordVisible;
    };
    SetPasswordComponent.prototype.setPasswordRecentlyUsed = function () {
        this.passwordRecentlyUsed = true;
        this.changeDetector.markForCheck();
    };
    SetPasswordComponent.prototype.resetErrors = function () {
        this.passwordRecentlyUsed = false;
        this.changeDetector.markForCheck();
    };
    SetPasswordComponent.prototype.createGroup = function () {
        this.initPasswordValidationPattern();
        var validators = [Validators.required];
        // check whether the entered password has a number
        if (this.validateNumber) {
            validators.push(patternValidator(/\d/, { hasNumber: true }));
        }
        // check whether the entered password has upper case letter
        if (this.validateUpperChar) {
            validators.push(patternValidator(/[A-Z]/, { hasCapitalCase: true }));
        }
        // check whether the entered password has a lower-case letter
        if (this.validateLowerChar) {
            validators.push(patternValidator(/[a-z]/, { hasSmallCase: true }));
        }
        // check whether the entered password has a special character
        if (this.validateSpecialChar) {
            validators.push(patternValidator(/[^\w\s]/, { hasSpecialCharacters: true }));
        }
        // has a minimum length of 8 characters
        if (this.validateLength) {
            validators.push(Validators.minLength(this.passwordLength));
        }
        // check whether the entered password has more than 2 consecutive chars
        if (this.validateConsecutiveChars) {
            validators.push(antiPatternValidator(/([^\w\s]|[a-zA-Z0-9])\1\1+/, { lessThanTwoConsecutiveChars: true }));
            // if in the future we want to validate consecutive sequential chars
            // ([^\w\s]|[a-zA-Z0-9])\1\1+|(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|012|123|234|345|456|567|678|789)+
        }
        return this.formControls = new FormGroup({
            password: new FormControl('', { validators: tslib_1.__spread(validators) }),
            confirmPassword: new FormControl('', { validators: [Validators.required] })
        }, { validators: [Validators.required, passwordMatchValidator({ passwordsMismatch: true })] });
    };
    SetPasswordComponent.prototype.initPasswordValidationPattern = function () {
        var passwordPattern;
        if (this.tokenProvider.isAuthenticated()) {
            passwordPattern = this.sysConfig.UserPasswordPattern;
        }
        else {
            passwordPattern = this.sysConfigPreLogin.UserPasswordPattern;
        }
        if ((passwordPattern & 1) === 1) {
            this.validateNumber = true;
        }
        if ((passwordPattern & 2) === 2) {
            this.validateUpperChar = true;
        }
        if ((passwordPattern & 4) === 4) {
            this.validateLowerChar = true;
        }
        if ((passwordPattern & 8) === 8) {
            this.validateSpecialChar = true;
        }
        if ((passwordPattern & 16) === 16) {
            this.validateLength = true;
            if (this.tokenProvider.isAuthenticated()) {
                this.passwordLength = this.sysConfig.UserPasswordLength;
            }
            else {
                this.passwordLength = this.sysConfigPreLogin.UserPasswordLength;
            }
        }
        if ((passwordPattern & 32) === 32) {
            this.validateConsecutiveChars = true;
        }
    };
    return SetPasswordComponent;
}());
export { SetPasswordComponent };
